import { createApp } from "vue";
import AdminReportsWidget from "./components/AdminReportsWidget.vue";
import { getMountElements, readPayload, VUE_MOUNTED_ATTRIBUTE } from "./utils/vueMount";

const MOUNT_SELECTOR = "[data-vue-admin-reports]";

export function initAdminReportsApp(root = document) {
  const apps = [];

  for (const element of getMountElements(root, MOUNT_SELECTOR)) {
    if (element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      continue;
    }

    const payload = readPayload(element);
    const app = createApp(AdminReportsWidget, {
      metadataUrl: payload.metadataUrl || "",
      previewUrl: payload.previewUrl || "",
      exportUrl: payload.exportUrl || "",
      personnelPdfUrl: payload.personnelPdfUrl || "",
      csrfToken: payload.csrfToken || "",
      csrfFieldName: payload.csrfFieldName || "_csrf",
      initialCatalog: payload.initialCatalog || {},
      initialState: payload.initialState || {},
    });

    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  }

  return apps;
}
